/**
* SxaAssessmentResultsTile.jsTile.js
*
* Copyright (c) 2018-2019 i-Solutions Global Ltd. All Rights Reserved.
*
* This software is the confidential and proprietary information of
* i-Solutions Global Ltd. ("Confidential Information").  You shall
* not disclose such Confidential Information and shall use it only in
* accordance with the terms of the license agreement you entered into
* with i-Solutions Global Ltd.
*
* I-SOLUTIONS GLOBAL LTD MAKES NO REPRESENTATIONS OR WARRANTIES ABOUT
* THE SUITABILITY OF THE SOFTWARE, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT
* LIMITED TO THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
* PARTICULAR PURPOSE, OR NON-INFRINGEMENT. I-SOLUTIONS GLOBAL LTD SHALL NOT BE
* LIABLE FOR ANY DAMAGES SUFFERED BY LICENSEE AS A RESULT OF USING, MODIFYING OR
* DISTRIBUTING THIS SOFTWARE OR ITS DERIVATIVES.
*
* Version 1.0
*/

import React from 'react';
import PropTypes from 'prop-types';

import axios from "axios";

import StratexReportThumbnail from './images/inx_report.png';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';

// Sxa components
import SxaProcessAreaResultTile from './SxaProcessAreaResultTile';

const styles = theme => ({
    labelContainer: {
        fontSize: 14,
        fontFamily: 'Open Sans, sans-serif',
        marginBottom: 4,
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        margin: 'auto',
        width: 'fit-content',
    },
    formControl: {
        marginTop: theme.spacing.unit * 2,
        minWidth: 120,
    },
    formControlLabel: {
        marginTop: theme.spacing.unit,
    },
    reportTitle: {
        fontSize: 22,
        fontFamily: 'Open Sans, sans-serif',
        fontWeight: "bold",
        marginBottom: 4,
        color: "#1e2b56"
    },
    reportDate: {
        fontSize: 14,
        fontFamily: 'Open Sans, sans-serif',
        marginBottom: 4,
        color: "#1e2b56"
    },
    reportInstruction: {
        fontSize: 15,
        fontFamily: 'Open Sans, sans-serif',
        marginBottom: 4,
        width: "60%",
        color: "#1e2b56"
    },
    reportSummary: {
        fontSize: 18,
        fontFamily: 'Open Sans, sans-serif',
        fontWeight: "bold",
        marginBottom: 4,
        color: "#1e2b56"
    },
    reportBody: {
        fontSize: 16,
        fontFamily: 'Open Sans, sans-serif',
        marginBottom: 4,
        color: "#1e2b56"
    },
    reportMandatory: {
        fontSize: 12,
        fontFamily: 'Open Sans, sans-serif',
        marginBottom: 2,
        color: "#1e2b56"
    },
    reportGLabel1: {
        fontSize: 16,
        fontFamily: 'Open Sans, sans-serif',
        marginTop: 4,
        marginBottom: 2,
        color: "#1e2b56"
    },
    reportGLabel2: {
        fontSize: 14,
        fontFamily: 'Open Sans, sans-serif',
        marginTop: 2,
        marginBottom: 2,
        color: "#1e2b56"
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        fontFamily: 'Open Sans, sans-serif',
    },
});

class SxaAssessmentResultsTile extends React.Component {
    constructor(props) {
        super(props);

        // Compute various numeric values needed for the report graphic

        // N.B. Need chart width to allow for 1/2 width of the score cursor
        // overlap on left and right edges
        // => plot area is chart width - cursor width and all X coords need to be adjusted by + 1/2 cursor width
        var iCursorWidth = 60;

        // Report graphic is 800px + 1 score cursor width wide
        var iSVGWidth = 800 + iCursorWidth;
        var iAdjustX = iCursorWidth / 2;

        var procCount = props.ass.processAreas.length;
        var svgHeight = 20 + (procCount * 48);

        // Add Y space for score cursor and label
        var adjusty = 35;
        var svgHeightAdjusted = svgHeight + adjusty;

        var iBand1X = 200 + iAdjustX;
        var iBand2X = 400 + iAdjustX;
        var iBand3X = 600 + iAdjustX;
        var iBand4X = 800 + iAdjustX;

        var polylineOne = iAdjustX + " " + adjusty + ", " + iBand4X + " " + adjusty + ", " + iBand4X + " " +
            svgHeightAdjusted + ", " + iAdjustX + " " + svgHeightAdjusted + ", " + iAdjustX + " " + adjusty;
        var polylineTwo = iBand1X + " " + adjusty + ", " + iBand1X + " " + svgHeightAdjusted;
        var polylineThree = iBand2X + " " + adjusty + ", " + iBand2X +  " " + svgHeightAdjusted;
        var polylineFour = iBand3X + " " + adjusty + ", " + iBand3X + " " + svgHeightAdjusted;


        // Assign A ref to state for refresh
        this.state = {
            ass: props.ass,
            open: false,
            fullWidth: true,
            maxWidth: 'md',
            checked: false,
            openMessage: false,
            openNosend: false,
            svgHeight: svgHeight,
            polylineOne: polylineOne,
            polylineTwo: polylineTwo,
            polylineThree: polylineThree,
            polylineFour: polylineFour,
            adjusty: adjusty,
            adjustx: iAdjustX,
            svgwidth: iSVGWidth,
        };
        // maxWidth settings: xs, sm, md, lg, xl

        // List of Process Area Result refs
        this.pars = [];

        this.handleClick = this.handleClick.bind(this);
    }

    updateResults(newA) {
        //console.log("Assessment_Results.updateResults(): newA = " + newA.oid);

        // Force re-render
        // Use function callback version
        this.setState( state => ({ ass: newA }) );

        // Use PAR refs to update the PA Result items
        var i = 0, nextPAR, nextPA;
        var len = this.pars.length;
        for (i; i < len; i++) {
            nextPAR = this.pars[i];
            nextPA = newA.processAreas[i];

            //console.log("Next PAR ref = " + nextPAR);

            nextPAR.updateResult(nextPA);
        }
    }

    // FIXME - move the Finish Button and handlers out of this component (into root level?)
    handleClick() {
        console.log("AA " + this.props.ass.oid + " Finish button clicked");

        // Compute the quadrant coordinate for the overall company score
        var overallscore = this.state.ass.score;
        var iAdjustX = this.state.adjustx;
        var scorex = 0 + iAdjustX;
        // N.B. Note the quadrant boundary check is >= the quadrant start
        if (overallscore >= 74.5) {
            scorex = 600 + iAdjustX;
        }
        else if (overallscore >= 49.5) {
            scorex = 400 + iAdjustX;
        }
        else if (overallscore >= 24.5) {
            scorex = 200 + iAdjustX;
        }
        this.setState( { scorex : scorex});

        // Report graphic is 800px wide
        var scorecenter = (overallscore * 8) + iAdjustX;
        var scoreleft = scorecenter - iAdjustX;
        var scoreright = scorecenter + iAdjustX;
        var polylineScore= scoreleft + ",22 "
            + scoreright + ",22 " +
            scorecenter + ",52 " +
            scoreleft + ",22";
        this.setState( { polylineScore : polylineScore});

        // TEST_BEGIN: viewbox for SVG (to render correctly in IE 11)
        // Example
        //<svg width="65%" viewBox="0 0 700 600">
        // NEW:
        //<svg width="100%" viewBox={this.state.svgviewbox} align="center">
        // ORIG:
        //<svg width={this.state.svgwidth} height={this.state.svgHeight + this.state.adjusty} align="center">
        var vbHeight = this.state.svgHeight + this.state.adjusty;
        var viewBoxString = "0 0 " + this.state.svgwidth + " " + vbHeight;
        this.setState({ svgviewbox: viewBoxString });
        // TEST_END

        // Quick and dirty X calc:
        // OLD: var scoreLabelX = (overallscore * 8) - 70;
        // NEW:
        // Compute text width to:
        // (a) center align correctly
        // (b) compute offset from right edge to avoid clipping (low score)
        // (c) compute offset from left edge to avoid clipping (high score)
        // FIXME - compute width using text + font-family + font-weight
        var scoreLabelWidth = 190;
        var labelX = scorecenter - (scoreLabelWidth / 2);
        var svgWidth = this.state.svgwidth;
        if (labelX < 0) {
            labelX = 0;
        }
        else if ( (labelX + scoreLabelWidth) > svgWidth) {
            labelX = svgWidth - scoreLabelWidth;
        }
        this.setState({ scorelabelx: labelX });

        // Set the Assessment to Finish state and pop Report dialog
        // Just pop the dialog
        this.setState({ open: true });
    }

    handleCloseMessage = () => {
        console.log("AA " + this.state.ass.oid + " Finish dialog Confirmation closed");
        this.setState({ openMessage: false });

        // Reset the send report fields
        console.log("Clearing landscape Finish dialog field values");
        this.setState({ guestfirst: "", guestlast: "",company: "", email: "", checked: false });

        // Also close the View report dialog
        this.handleClose();
    };

    handleCloseNosend = () => {
        this.setState({ openNosend: false });
    };

    handleClose = () => {
        console.log("AA " + this.state.ass.oid + " Finish dialog closed");
        this.setState({ open: false });
    };

    handleTextChange = name => event => {
        // email, company, guestfirst, guestlast
        //console.log("TextField change; name = " + name + "; value = " + event.target.value);
        this.setState({ [name]: event.target.value });
    };

    handleCheckChange = name => event => {
        // checked
        //console.log("Checkbox change; name = " + name + "; value = " + event.target.value);
        this.setState({ [name]: event.target.checked });
    };

    getTodayFormatted = () => {
        const date = new Date();
        return date.toLocaleDateString('en-GB',
            { day: 'numeric', month: 'short', year: 'numeric' });
    }

    // Utility method to do simple validate email
    validateEmail(email) {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

    handleSubmit = () => {
        console.log("AA " + this.state.ass.oid + " Submit user details: " +
            " guestfirst = " + this.state.guestfirst +
            " guestlast = " + this.state.guestlast +
            " company = " + this.state.company +
            " email = " + this.state.email +
            " checked = " + this.state.checked
        );

        // Check if submit ok
        // Check submit conditions:
        // (a) consent given - checked = true
        // (b) mandatory fields entered - values for guestfirst, guestlast, company, email
        // FIXME - check email valie - presence of @?
        if (this.state.checked === true &&
            this.state.guestfirst && this.state.guestlast && this.state.company && this.state.email &&
            this.validateEmail(this.state.email) === true)
        {
            console.log("Assessment Submit conditions met");
        }
        else {
            console.log("Assessment Submit conditions not met; ignoring Submit");

            // Pop message dialog
            this.setState({ openNosend: true });
            return;
        }

        // Call the server with the 3 fields + the flag to finish and generate the report
        document.body.style.cursor='wait';

        var url = 'api/assessment/finish?guestfirst=' + this.state.guestfirst + '&guestlast=' + this.state.guestlast +
            '&org=' + this.state.company + '&email=' + this.state.email + '&consent=' + this.state.checked;
        axios.get(url)
            .then(response => {
                console.log(response.data);

                document.body.style.cursor='auto';

                // Confirmation message (pop 2nd dialog)
                this.setState({ openMessage: true });
            })
            .catch(err => {
                document.body.style.cursor='auto';
                console.error(err)
            })
    }

    render() {
        const {classes} = this.props;
        return(
            <React.Fragment>
                { this.state.ass ? (
                    <div style={{maxWidth: "25rem"}}>
                        <Typography align="center" style={{fontSize: 16}}>
                            Assessment Results
                        </Typography>
                    <Grid container spacing={0}
                          style={{paddingTop: 6, paddingBottom: 36, paddingRight: 32, paddingLeft: 32}}
                          direction="row" justify="space-evenly" alignItems="stretch">
                        <Grid item xs={12} sm={12} lg={12} xl={12}>
                            <Grid container spacing={0} style={{padding: 0}}
                                  direction="row" justify="space-evenly" alignItems="stretch">
                                <Grid item xs={6} sm={6} lg={6} xl={6}>
                                    <Typography align="left" className={classes.labelContainer} >
                                        Overall Maturity
                                    </Typography>
                                </Grid>
                                <Grid item xs={6} sm={6} lg={6} xl={6}>
                                    <Typography align="right" className={classes.labelContainer} >
                                        {this.state.ass.completedQuestionCount} / {this.state.ass.questionCount}
                                    </Typography>
                                </Grid>
                            </Grid>
                            <svg width="100%" height="20">
                                <rect x="0" y="0" width="100%" height="20" fill="#84848d"/>
                                <rect x="1" y="1" width="99%" height="18" fill="white"/>
                                {this.state.ass.scoreComputed ?
                                    <rect x="0" y="0" width={this.state.ass.score + "%"} height="20" fill="#2e457b"/>
                                    : ""
                                }
                                {this.state.ass.scoreComputed ?
                                    <text x="6" y="14" fontFamily="Verdana" fontSize="12"
                                          fill={this.state.ass.score > 5 ? "white" : "#1e2b56"}>
                                        {this.state.ass.score}
                                    </text>
                                    :
                                    <text x="6" y="14" fontFamily="Verdana" fontSize="12" fill="#1e2b56">
                                        Assessment not complete
                                    </text>
                                }
                            </svg>
                            <Typography style={{padding: 10}} />
                        </Grid>
                        <Grid item xs={12} sm={12} lg={12} xl={12}>
                            { this.state.ass.processAreas.map( (nextPA, index) =>
                                <SxaProcessAreaResultTile par={nextPA} key={nextPA.oid}
                                                          innerRef={(par) => { this.pars[index] = (par); }}
                                />
                            )}
                        </Grid>
                        <Grid item xs={12} sm={12} lg={12} xl={12}>
                            { this.state.ass.scoreComputed? (
                                <div>
                                    <Button onClick={this.handleClick} variant="contained" color="primary"
                                            style={{marginTop: 24, backgroundColor: '#1976D2'}}>
                                        View report
                                    </Button>
                                    <Dialog
                                        fullWidth={this.state.fullWidth}
                                        maxWidth={this.state.maxWidth}
                                        open={this.state.open}
                                        onClose={this.handleClose}
                                        aria-labelledby="max-width-dialog-title"
                                    >
                                        <Grid container spacing={0}
                                                  style={{paddingLeft: 40, paddingRight: 40}}
                                                  direction="row" justify="space-evenly" alignItems="stretch">
                                            <Grid item xs={12} sm={12} lg={12} xl={12}>
                                                <Typography align="center" className={classes.reportTitle}
                                                            style={{marginTop: 12}}>
                                                    Assessment Results
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={12} lg={12} xl={12}>
                                                <Typography align="center" className={classes.reportDate} >
                                                    Completed on {this.getTodayFormatted()}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={12} lg={12} xl={12}>
                                                <div style={{paddingTop: 10, paddingBottom: 0, paddingLeft: 20, paddingRight: 20}}>
                                                    <svg width="100%" viewBox={this.state.svgviewbox} align="center">
                                                        <text x={this.state.scorelabelx} y="16" fontFamily="Verdana" fontSize="16" fill="#1e2b56">
                                                            Overall Company Score
                                                        </text>

                                                        <polyline points={this.state.polylineOne} style={{ stroke: "#afc6ee", width: 1, fill: "none"}} />
                                                        <polyline points={this.state.polylineTwo} style={{ stroke: "#afc6ee", width: 1, fill: "none"}} />
                                                        <polyline points={this.state.polylineThree} style={{ stroke: "#afc6ee", width: 1, fill: "none"}} />
                                                        <polyline points={this.state.polylineFour} style={{ stroke: "#afc6ee", width: 1, fill: "none"}} />

                                                        <rect x={this.state.scorex} y={this.state.adjusty} width="200" height={this.state.svgHeight} fill="#afc6ee"/>
                                                        <polyline points={this.state.polylineScore} style={{ stroke: "#ff8919", width: 1, fill: "#ff8919"}} />
                                                        <text x={this.state.adjustx +(this.state.ass.score * 8) - 8} y={this.state.adjusty + 2} fontFamily="Verdana" fontSize="12" fill="white">
                                                            {this.state.ass.score}
                                                        </text>

                                                        { this.state.ass.processAreas.map( (nextPA, index) =>
                                                            <g key={index}>
                                                                <text x={this.state.adjustx} y={this.state.adjusty + 20 + (index * 48)} fontFamily="Verdana" fontSize="12" fill={"#1e2b56"}>
                                                                    {nextPA.name}
                                                                </text>
                                                                <rect x={this.state.adjustx} y={this.state.adjusty + 25 + (index * 48)} width={nextPA.score * 8} height="20" fill="#2e457b"/>
                                                                <text x={this.state.adjustx + 6} y={this.state.adjusty + 40 + (index * 48)} fontFamily="Verdana" fontSize="12" fill={nextPA.score > 0 ? "white" : "#1e2b56"}>
                                                                    {nextPA.score}
                                                                </text>
                                                            </g>
                                                        )}
                                                    </svg>
                                                </div>
                                            </Grid>
                                            <Grid item xs={12} sm={12} lg={12} xl={12}>
                                                <div style={{paddingTop: 10, paddingBottom: 10, paddingLeft: 40, paddingRight: 40}}>
                                                    <Grid container spacing={0} style={{padding: 0, paddingLeft: this.state.adjustx, paddingRight: this.state.adjustx}}
                                                          direction="row" justify="space-evenly" alignItems="stretch">
                                                        <Grid item xs={3} sm={3} lg={3} xl={3}>
                                                            <Typography align="center" className={classes.reportGLabel1} >
                                                                Traditional
                                                            </Typography>
                                                            <Typography align="center" className={classes.reportGLabel2} >
                                                                Level 1
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={3} sm={3} lg={3} xl={3}>
                                                            <Typography align="center" className={classes.reportGLabel1} >
                                                                Disciplined
                                                            </Typography>
                                                            <Typography align="center" className={classes.reportGLabel2} >
                                                                Level 2
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={3} sm={3} lg={3} xl={3}>
                                                            <Typography align="center" className={classes.reportGLabel1} >
                                                                Aligned
                                                            </Typography>
                                                            <Typography align="center" className={classes.reportGLabel2} >
                                                                Level 3
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={3} sm={3} lg={3} xl={3}>
                                                            <Typography align="center" className={classes.reportBody} >
                                                                Integrated
                                                            </Typography>
                                                            <Typography align="center" className={classes.reportGLabel2} >
                                                                Level 4
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                </div>
                                            </Grid>
                                            <Grid item xs={12} sm={12} lg={12} xl={12}>
                                                <div style={{paddingTop: 10, paddingBottom: 0, paddingLeft: 40, paddingRight: 40}}>
                                                    <Typography align="left" className={classes.reportSummary}>
                                                        Summary
                                                    </Typography>
                                                </div>
                                            </Grid>
                                            <Grid item xs={12} sm={12} lg={12} xl={12}>
                                                <div style={{paddingTop: 10, paddingBottom: 0, paddingLeft: 40, paddingRight: 40}}>
                                                    <Grid container spacing={0} style={{padding: 0}}
                                                          direction="row" justify="space-evenly" alignItems="stretch">
                                                        <Grid item xs={6} sm={6} lg={6} xl={6}>
                                                            <Typography align="left" className={classes.reportBody} >
                                                                {this.state.ass.reportTextOne}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={6} sm={6} lg={6} xl={6}>
                                                            <Typography align="left" className={classes.reportBody} >
                                                                {this.state.ass.reportTextTwo}
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                </div>
                                            </Grid>
                                            <Grid item xs={12} sm={12} lg={12} xl={12}>
                                                <div style={{paddingTop: 10, paddingBottom: 0, paddingLeft: 40, paddingRight: 40}}>
                                                    <Typography align="left" className={classes.reportTitle}
                                                                style={{marginTop: 10}}>
                                                        FREE complimentary report
                                                    </Typography>
                                                </div>
                                            </Grid>
                                            <Grid item xs={12} sm={12} lg={12} xl={12}>
                                                <Grid container spacing={0}
                                                      style={{paddingTop: 0, paddingBottom: 0, paddingLeft: 40, paddingRight: 40}}
                                                      direction="row" justify="space-evenly" alignItems="stretch">
                                                    <Grid item xs={2} sm={2} lg={2} xl={2} >
                                                        <img src={StratexReportThumbnail} alt="Thumb"
                                                             align="left" width="120" style={{ marginTop: 6 }}/>
                                                    </Grid>
                                                    <Grid item xs={4} sm={4} lg={4} xl={4}>
                                                        <Typography align="left" className={classes.reportInstruction} >
                                                            To receive your full complimentary report, please fill in this form and you will get a copy via email.
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={6} sm={6} lg={6} xl={6}>
                                                        <Grid container spacing={0} style={{padding: 0}}
                                                              direction="row" justify="space-evenly" alignItems="stretch">
                                                            <Grid item xs={12} sm={12} lg={12} xl={12}>
                                                                <TextField
                                                                    id="outlined-namefirst"
                                                                    onChange={this.handleTextChange('guestfirst')}
                                                                    label="Enter First Name*"
                                                                    className={classes.textField}
                                                                    variant="outlined"
                                                                    margin="dense"
                                                                    style={{ width: "100%"}}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} sm={12} lg={12} xl={12}>
                                                                <TextField
                                                                    id="outlined-namelast"
                                                                    onChange={this.handleTextChange('guestlast')}
                                                                    label="Enter Last Name*"
                                                                    className={classes.textField}
                                                                    variant="outlined"
                                                                    margin="dense"
                                                                    style={{ width: "100%"}}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} sm={12} lg={12} xl={12}>
                                                                <TextField
                                                                    id="outlined-company"
                                                                    onChange={this.handleTextChange('company')}
                                                                    label="Enter Company*"
                                                                    className={classes.textField}
                                                                    variant="outlined"
                                                                    margin="dense"
                                                                    style={{ width: "100%"}}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} sm={12} lg={12} xl={12}>
                                                                <TextField
                                                                    id="outlined-email"
                                                                    onChange={this.handleTextChange('email')}
                                                                    label="Enter Email*"
                                                                    className={classes.textField}
                                                                    type="email"
                                                                    name="email"
                                                                    autoComplete="email"
                                                                    variant="outlined"
                                                                    margin="dense"
                                                                    style={{ width: "100%"}}
                                                                    helperText="* Mandatory fields"
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} sm={12} lg={12} xl={12}>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            // Controlled component? checked={this.state.checked}
                                                                            onChange={this.handleCheckChange('checked')}
                                                                            value="checked"
                                                                            color="primary"
                                                                        />
                                                                    }
                                                                    label="I consent to receiving i-nexus marketing material"
                                                                    labelPlacement="start"
                                                                    style={{ width: "100%", color: "#1e2b56", align: "right"}}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} sm={12} lg={12} xl={12}>
                                                                <Button onClick={this.handleSubmit} variant="contained"
                                                                        color="primary"
                                                                        align="right"
                                                                        style={{
                                                                            marginTop: 2,
                                                                            marginBottom: 20,
                                                                            backgroundColor: '#1976D2'
                                                                        }}>
                                                                    Send report
                                                                </Button>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Dialog>

                                    <Dialog
                                        open={this.state.openMessage}
                                        onClose={this.handleCloseMessage}
                                        aria-labelledby="max-width-dialog-title"
                                    >
                                        <DialogTitle id="simple-dialog-title">Your FREE complimentary report has been sent</DialogTitle>
                                        <DialogContent>
                                            <Typography align="left" className={classes.reportBody} >
                                                Thank you for completing the assessment.
                                            </Typography>
                                        </DialogContent>
                                    </Dialog>

                                    <Dialog
                                        open={this.state.openNosend}
                                        onClose={this.handleCloseNosend}
                                        aria-labelledby="max-width-dialog-title"
                                    >
                                        <DialogTitle id="simple-dialog-title">Your FREE complimentary report was NOT sent</DialogTitle>
                                        <DialogContent>
                                            <Typography align="left" className={classes.reportBody} >
                                                Please complete all fields including consent.
                                            </Typography>
                                        </DialogContent>
                                    </Dialog>
                                </div>
                            ) : ""
                            }
                        </Grid>
                    </Grid>
                    </div>
                ) : "No Assessment found" }
            </React.Fragment>
        )
    }
}

/*
Removed instructions:
    <Typography align="left" className={classes.reportBody} >
        Click out of this dialog to return to the Assessment view.
    </Typography>
 */

SxaAssessmentResultsTile.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SxaAssessmentResultsTile);